var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutForm", [
    _c("h1", { attrs: { slot: "header" }, slot: "header" }, [
      _vm._v("Create Intelligence"),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "form",
        attrs: { novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("ValidationAlert", {
          attrs: { "error-list": _vm.errors.collect("server") },
        }),
        _vm._v(" "),
        _c(
          "fieldset",
          { staticClass: "form__group" },
          [
            _c("FormControlSector", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
              ],
              attrs: { name: "sectors", multiple: true },
              model: {
                value: _vm.formData.sectors,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "sectors", $$v)
                },
                expression: "formData.sectors",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.content,
                    expression: "formData.content",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "intel-content",
                  name: "content",
                  placeholder: "Enter your intel here...",
                  required: "",
                },
                domProps: { value: _vm.formData.content },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "content", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form__label", attrs: { for: "intel-content" } },
                [_vm._v("Add your Intel")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("content"))),
              ]),
            ]),
            _vm._v(" "),
            _c("FormControlDealType", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
              ],
              attrs: { name: "dealType" },
              model: {
                value: _vm.formData.dealType,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "dealType", $$v)
                },
                expression: "formData.dealType",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form__group form__group--submit" },
              [
                _c(
                  "router-link",
                  { staticClass: "btn", attrs: { to: "/intelligence" } },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c("button", { staticClass: "btn btn--primary" }, [
                  _vm._v("Save & Preview"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }